class Mp4 {
    constructor() {
        // global class identifier
        this.class = {
            videoWrapper: '.mp4-video-module',
            videoBtn: '.mp4-video-module-btn',
            videoCopyright: '.mp4-video-module-copyright',
            videoItem: '.mp4-video-module-item',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * init mp4 video player
     */
    videoMp4Player() {
        const videoWrapper = document.querySelectorAll(this.class.videoWrapper);
        if (videoWrapper.length > 0) {
            videoWrapper.forEach((wrapper) => {
                // trigger button
                wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                    const trigger = e.currentTarget.parentElement;
                    trigger.closest(this.class.videoWrapper).querySelector(this.class.videoBtn).classList.add('d-none');
                    const isCopyrightExisting = document.getElementsByClassName('mp4-video-module-copyright');
                    if (isCopyrightExisting.length > 0) {
                        // eslint-disable-next-line max-len
                        const videoCopyright = trigger.closest(this.class.videoWrapper).querySelector(this.class.videoCopyright);
                        if (videoCopyright !== null) {
                            // eslint-disable-next-line max-len
                            videoCopyright.classList.add('d-none');
                        }
                    }
                    // eslint-disable-next-line max-len
                    const video = trigger.closest(this.class.videoWrapper).querySelector(this.class.videoItem);
                    video.play();
                });

                // trigger html video player
                const currentVideo = document.querySelector(`#mp4-video-item-${wrapper.dataset.id}`);
                currentVideo.addEventListener('play', () => {
                    document.querySelector(`#mp4-video-module-${wrapper.dataset.id} .mp4-video-module-btn`).classList.add('d-none');
                    const isCopyrightExisting = document.getElementsByClassName('mp4-video-module-copyright');
                    if (isCopyrightExisting.length > 0) {
                        // eslint-disable-next-line max-len
                        const videoCopyright = document.querySelector(`#mp4-video-module-${wrapper.dataset.id} .mp4-video-module-copyright`);
                        if (videoCopyright !== null) {
                            // eslint-disable-next-line max-len
                            videoCopyright.classList.add('d-none');
                        }
                    }
                }, false);
            });
        }
    }

    init() {
        this.videoMp4Player();
    }
}

export default new Mp4();
